// CELINE-inspired theme functionality
document.addEventListener('DOMContentLoaded', function() {
  const body = document.body;
  const mobileMenuOpen = document.querySelector('.mobile-menu-open');
  const mobileMenuClose = document.querySelector('.mobile-close');
  const overlay = document.querySelector('.menu-overlay');

  function openMenu() {
    body.classList.add('menu-open');
  }

  function closeMenu() {
    body.classList.remove('menu-open');
  }

  // Mobile menu toggle
  if (mobileMenuOpen) {
    mobileMenuOpen.addEventListener('click', openMenu);
  }

  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', closeMenu);
  }

  // Close menu on overlay click
  document.addEventListener('click', function(e) {
    if (body.classList.contains('menu-open') && !e.target.closest('.theme-sidebar') && !e.target.closest('.mobile-menu-open')) {
      closeMenu();
    }
  });

  // Close menu on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && body.classList.contains('menu-open')) {
      closeMenu();
    }
  });

  // Prevent scrolling when menu is open on mobile
  document.addEventListener('touchmove', function(e) {
    if (body.classList.contains('menu-open')) {
      e.preventDefault();
    }
  }, { passive: false });
});